import React, { CSSProperties } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Prose } from '@nikolovlazar/chakra-ui-prose';

type Props = {
  content: string;
  className?: string;
  style?: CSSProperties;
};

export function MarkdownBlock(props: Props) {
  const { content, ...otherProps } = props;
  return (
    <Prose as="div" {...otherProps}>
      <ReactMarkdown
        components={{
          a: (props) => <a {...props} target="_blank" rel="noreferrer" />,
        }}
        remarkPlugins={[
          // Github flavored markdown
          remarkGfm,
        ]}
        skipHtml
      >
        {content}
      </ReactMarkdown>
    </Prose>
  );
}
